import { render, staticRenderFns } from "./polyCode.vue?vue&type=template&id=2b633094&scoped=true"
import script from "./polyCode.vue?vue&type=script&lang=js"
export * from "./polyCode.vue?vue&type=script&lang=js"
import style0 from "./polyCode.vue?vue&type=style&index=0&id=2b633094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b633094",
  null
  
)

export default component.exports